import { ROWFormData } from 'components/Signup/ROWWaitingListForm';
import { addUTMData, trackLeadToPensieve } from './utils/helpers';
import { WaitingList } from './types';

interface TrackingData extends ROWFormData {
  firstName: string | undefined;
  lastName: string | undefined;
}

export const ROWwaitingListTracking = (formData: TrackingData) => {
  const { firstName, lastName, email, country, marketingConsent } = formData;

  const baseData = {
    firstName,
    lastName,
    email,
    country,
    marketingConsent,
    marketingConsentDate: marketingConsent ? new Date().toISOString() : '',
    signup_waiting_list: WaitingList.ROW,
    company: {
      name: email,
    },
  };

  const dataWithUTM = addUTMData(baseData);

  trackLeadToPensieve(dataWithUTM);
};
